import React from 'react';
import { func, object, string } from 'prop-types';
import { css } from '@emotion/css';

import { Button } from '@ajaibid/components';
import useAutoOrderAction from '../hooks/useAutoOrderAction';

export const styActionButtonsContainer = css`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
`;

/**
 * @param {object}  ComponentParams
 * @param {import('@services/api/stock/order/auto/order').AutoOrder}  ComponentParams.autoOrder
 */
function ActionButtons({ autoOrder }) {
  const isOpen = autoOrder.order_status === 'OPEN';
  const { amend, withdraw } = useAutoOrderAction(autoOrder);

  return (
    <span className={styActionButtonsContainer}>
      {isOpen && (
        <Button variant="secondary" minWidth={null} onClick={amend}>
          Ubah
        </Button>
      )}
      <Button variant="secondary" minWidth={null} onClick={withdraw}>
        Hapus
      </Button>
    </span>
  );
}

ActionButtons.propTypes = {
  autoOrder: object.isRequired,
};

export default ActionButtons;
